  <div class="container px-lg-0 pt-20 pb-20 d-none d-lg-block">
    <div class="glass-back-button" [routerLink]="'/rewards/raffles'">
      <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
    </div>
  </div>
<!--Point Summary Bar-->
<div class="container d-lg-none">
  <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'"></fgb-points-summary-bar>
</div>
<!--Lotto Details-->
<fgbcl-lotto-details-v2 [lottoId]="id" />
